export default "__VITE_ASSET__a3723e0a__"